module.exports = __webpack_public_path__ + "static/laptopWorking-7ed1c2ce1352ba131fae3c435a7be9a9.jpg";